module.exports = __webpack_public_path__ + "static/media/13.b4f0b75b.jpg";